const progressAppearanceMap = {
    critical: 'red',
    notable: 'yellow',
    minor: 'blue',
    approved: 'ai',
};
export const getAppearance = (type) => progressAppearanceMap[type];
